import { useMutation } from '@apollo/client'
import {
  RemoveCriterionOptionV2Mutation,
  RemoveCriterionOptionV2MutationVariables
} from '../../data/gql-gen/questionnaire/graphql'
import { REMOVE_CRITERION_OPTION_V2 } from '../../data/gql/questionnaire/mutations/criterionOptionV2'
import { audienceQuestionLogicRefetchQueries } from '../../data/gql/questionnaire/queries/audienceQuestionLogic'
import { draftAudienceRefetchQuery } from '../../data/gql/questionnaire/queries/audiences'
import { customCriteriaRefetchQuery } from '../../data/gql/questionnaire/queries/customCriteria'
import { LoggerErrorType } from '../../data/logger'
import { captureApolloError } from '../../utils/HelperFunctions'
import { useOptionalWaveId } from '../useOptionalWaveId'
import { useProjectId } from '../useProjectId'
import { useSurveyId } from '../useSurveyId'

export const useRemoveCriterionOptionV2 = () => {
  const projectId = useProjectId()
  const surveyId = useSurveyId()
  const waveId = useOptionalWaveId()
  const [removeCriterionOptionV2Mutation] = useMutation<
    RemoveCriterionOptionV2Mutation,
    RemoveCriterionOptionV2MutationVariables
  >(REMOVE_CRITERION_OPTION_V2, {
    context: { clientName: 'questionnaire' },
    onError(error) {
      captureApolloError(
        LoggerErrorType.ApolloMutation,
        'removeCriterionOptionV2',
        error
      )
    },
    refetchQueries: [
      draftAudienceRefetchQuery(projectId, surveyId, waveId),
      customCriteriaRefetchQuery(projectId, surveyId, waveId),
      ...audienceQuestionLogicRefetchQueries(projectId, surveyId, waveId)
    ]
  })

  return (questionId: string, responseOptionId: string) =>
    removeCriterionOptionV2Mutation({
      variables: {
        input: {
          projectId,
          surveyId,
          waveId,
          questionId,
          responseOptionId
        }
      }
    })
}
